var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { rechartsDiagonalStripeSwatchCss } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { widgetMetricCellBadgeDiff } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import BadgeDiff from '@web/components/ui/Badge/BadgeDiff';
import { TablesDiffColorsConfig } from '@web/config';
var LegendItem = function (_a) {
    var color = _a.color, chartColor = _a.chartColor, label = _a.label, currentValue = _a.currentValue, diffValue = _a.diffValue, teamAverage = _a.teamAverage, arrowColor = _a.arrowColor, stripeChartColor = _a.stripeChartColor, currentValueClassName = _a.currentValueClassName, onClick = _a.onClick, onValueClick = _a.onValueClick, _b = _a.isHidden, isHidden = _b === void 0 ? false : _b;
    var toggleClassName = onClick
        ? 'cursor-pointer rounded-md transition-opacity hover:opacity-80'
        : '';
    var valueClassName = [
        currentValueClassName !== null && currentValueClassName !== void 0 ? currentValueClassName : 'text-sm font-semibold',
        onValueClick ? 'cursor-pointer rounded-md hover:opacity-80' : ''
    ]
        .filter(Boolean)
        .join(' ');
    var displayLabel = currentValue != null ? "".concat(label, ":") : label;
    var swatchAndLabel = (_jsxs(_Fragment, { children: [stripeChartColor ? (_jsx("div", { className: "h-4 w-4 shrink-0 rounded border border-gray-200", style: {
                    background: rechartsDiagonalStripeSwatchCss(stripeChartColor)
                }, "aria-hidden": true })) : chartColor ? (_jsx("div", { className: "h-4 w-4 shrink-0 rounded", style: { backgroundColor: chartColor }, "aria-hidden": true })) : (_jsx("div", { className: "w-4 h-4 rounded ".concat(color !== null && color !== void 0 ? color : '') })), _jsx("span", __assign({ className: "text-sm" }, { children: displayLabel }))] }));
    var valueNode = currentValue != null ? (onValueClick ? (_jsx("button", __assign({ type: "button", onClick: onValueClick, className: valueClassName }, { children: currentValue }))) : (_jsx("span", __assign({ className: valueClassName }, { children: currentValue })))) : null;
    var badges = teamAverage ? (_jsxs(_Fragment, { children: [_jsx(BadgeDiff, { diffValue: diffValue, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.GREEN }), _jsx(BadgeDiff, { diffValue: teamAverage, customStyles: widgetMetricCellBadgeDiff, arrowColor: TablesDiffColorsConfig.BLUE })] })) : (diffValue && (_jsx(BadgeDiff, { diffValue: diffValue, customStyles: widgetMetricCellBadgeDiff, arrowColor: arrowColor })));
    var rowClassName = [
        'flex shrink-0 items-center gap-2 whitespace-nowrap',
        isHidden ? 'opacity-40' : ''
    ]
        .filter(Boolean)
        .join(' ');
    if (onClick && onValueClick) {
        return (_jsxs("div", __assign({ className: rowClassName }, { children: [_jsx("button", __assign({ type: "button", onClick: onClick, "aria-pressed": !isHidden, className: "flex items-center gap-2 ".concat(toggleClassName) }, { children: swatchAndLabel })), valueNode, badges] })));
    }
    var content = (_jsxs(_Fragment, { children: [swatchAndLabel, valueNode, badges] }));
    var className = [rowClassName, toggleClassName].filter(Boolean).join(' ');
    if (onClick) {
        return (_jsx("button", __assign({ type: "button", onClick: onClick, "aria-pressed": !isHidden, className: className }, { children: content })));
    }
    return _jsx("div", __assign({ className: rowClassName }, { children: content }));
};
export default LegendItem;
